import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { supabase } from "@/integrations/supabase/client";

const TRACKED_KEY = "eureka-pv-tracked";

export const usePageViewTracker = () => {
  const location = useLocation();

  useEffect(() => {
    // Skip admin pages
    if (location.pathname.startsWith("/admin")) return;

    // Debounce: don't track the same path twice in quick succession
    const key = `${TRACKED_KEY}-${location.pathname}`;
    const lastTracked = sessionStorage.getItem(key);
    const now = Date.now();
    if (lastTracked && now - parseInt(lastTracked) < 5000) return;
    sessionStorage.setItem(key, now.toString());

    // Mesure d'audience anonyme : uniquement la page consultée
    supabase.functions
      .invoke("track-page-view", {
        body: { pagePath: location.pathname },
      })
      .then(({ error }) => {
        if (error) console.error("Page view tracking error:", error);
      });
  }, [location.pathname]);
};
